import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';

import { IGeocodeFeature } from '@/services/types/mapbox/mapboxApi';
import { itemizeAddress } from '@/utility/itemizeAddress';

interface IMapAddressProps {
  place: IGeocodeFeature;
  isRetrieved: boolean;
}

export const MapAddress = ({ place, isRetrieved }: IMapAddressProps) => {
  const { name, place_formatted } = place?.properties || {};

  const { state, country, city } = itemizeAddress(place);

  const title = isRetrieved ? name : city;
  const subtitle = isRetrieved ? place_formatted : `${state}, ${country}`;

  return (
    <div className="flex flex-col p-4 gap-[2px] min-w-[200px]">
      <Text variant={ETextStyleVariant.MediumBold}>{title}</Text>
      <Text variant={ETextStyleVariant.SmallRegular}>{subtitle}</Text>
    </div>
  );
};
